export const LoginWithCode = async (code: string) => {
    const data = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/claim`, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ code }),
        headers: { 'Content-Type': 'application/json' }
    })
    const result = await data.json()
    if (data.status === 200) {
        return result
    } else {
        throw new Error(result.detail)
    }
}